"use client";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import CommonButton from "./CommonButton";
import { emailResendOtpVerification } from "@/services/pricing";
import { showToast } from "../../utils/libs/toast-utilis";

const OtpModal = ({
  show,
  onHide,
  verifyOTP,
  loading,
  userDetails,
  error = {},
  isEdit = false,
}) => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(30);
  const [resendAvailable, setResendAvailable] = useState(false);
  const inputsRef = useRef([]);
  useEffect(() => {
    if (show && inputsRef?.current?.length > 0) {
      setTimeout(() => {
        inputsRef.current[0].focus();
      }, 300);
    }
  }, [show]);
  // Countdown logic
  useEffect(() => {
    let countdown;
    if (show && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    if (timer === 0) {
      setResendAvailable(true);
    }

    return () => clearInterval(countdown);
  }, [show, timer]);
  useEffect(() => {
    if (error?.length > 0) {
      setOtp(["", "", "", "", "", ""]);
      inputsRef.current.forEach((input) => {
        if (input) input.value = "";
      });
    }
  }, [error]);
  const handleChange = (index, value) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pastedData = e.clipboardData.getData("text").slice(0, 6).split("");
    const newOtp = otp.map((_, i) => pastedData[i] || "");
    setOtp(newOtp);

    pastedData.forEach((char, i) => {
      const input = inputsRef.current[i];
      if (input) {
        input.value = char;
      }
    });

    const focusIndex = Math.min(pastedData.length, 5);
    inputsRef.current[focusIndex]?.focus();
  };

  const handleVerify = () => {
    const fullOtp = otp.join("");
    verifyOTP(fullOtp);
    // Add your verify API here
  };

  const handleResend = async () => {
    setOtp(["", "", "", "", "", ""]);
    inputsRef.current.forEach((input) => {
      if (input) input.value = "";
    });
    const query = isEdit
      ? { _id: userDetails?._id, email: userDetails?.email }
      : { email: userDetails?.email };

    try {
      const res = await emailResendOtpVerification(query);
      setTimer(30);
      inputsRef.current[0].focus();
      setResendAvailable(false);
    } catch (error) {
      if (error?.message) {
        showToast.error(error?.message);
        // onHide();
      }
    }
  };

  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show={show}
      onHide={() => {
        setTimer(30);
        onHide();
        setOtp(["", "", "", "", "", ""]);
        inputsRef.current.forEach((input) => {
          if (input) input.value = "";
        });
      }}
      centered
    >
      <Modal.Header closeButton className="border-0">
        <Modal.Title>
          Verify Your Email<span>.</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        className="pt-0"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleVerify();
          }
        }}
      >
        <p className="mb-3 text-center">
          OTP sent to your email <b>{userDetails?.email}</b>
        </p>
        <div
          className="d-flex justify-content-center gap-3 mb-3"
          onPaste={handlePaste}
        >
          {[...Array(6)].map((_, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={otp[index]}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              ref={(el) => (inputsRef.current[index] = el)}
              style={{
                width: "40px",
                height: "40px",
                textAlign: "center",
                fontSize: "20px",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
          ))}
        </div>

        {/* {error && (
          <div className="invalid-feedback d-block text-center">{error}</div>
        )} */}
        <div className="d-flex justify-content-end gap-3 align-items-center mt-3">
          {timer > 0 && (
            <div className="me-auto">
              <span className="text-muted"></span>
            </div>
          )}
          {/* {resendAvailable && ( */}
          <CommonButton
            label={"Resend OTP " + (timer > 0 ? "in " + timer : "")}
            className="black-border"
            variant="outline"
            disabled={loading || !resendAvailable}
            onClick={handleResend}
          />
          {/* )} */}
          {/* <Link href="/custom-pricing"> */}
          <CommonButton
            label="Verify"
            disabled={loading}
            className="btn-primary"
            onClick={handleVerify}
          />
          {/* </Link> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OtpModal;
